import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as SCHEMEACTIONS } from "../../../store/actions/schemeActions";
import Select from "react-select";
import cleanDeep from "clean-deep";
import SchemeRow from "./SchemesRow";
import { PlusIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import Spinner from "../../common/Spinner";
import LoadingContent from "../../common/LoadingContent";
import DeleteSchemeModal from "./DeleteSchemeModal";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "../../common/DateComponents";
import { format } from "date-fns";

const Schemes = ({
	getSchemes,
	schemes,
	schemeTypeOptions,
	pensionProviderOptions,
	schemeLoading,
	schemeUpdating,
	org,
	setOpenModal,
	permissions,
}) => {
	const [type, setType] = useState();
	const [pensionProvider, setPensionProvider] = useState();
	const [startDate, setStartDate] = useState(() => {
		const today = new Date();
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		return new Date(firstDayOfMonth.getTime() - firstDayOfMonth.getTimezoneOffset() * 60000);
	});
	const [endDate, setEndDate] = useState(() => {
		const today = new Date();
		const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		return new Date(lastDayOfMonth.getTime() - lastDayOfMonth.getTimezoneOffset() * 60000);
	});

	const updateSchemes = () => {
		getSchemes(
			cleanDeep({
				type: type?.value,
				pensionProvider: pensionProvider?.value,
				start: format(startDate, "yyyy-MM-dd"),
				end: format(endDate, "yyyy-MM-dd"),
			}),
		);
	};

	useEffect(() => {
		if (!schemes?.length) updateSchemes();
	}, [org]);

	if (!schemeTypeOptions || !pensionProviderOptions) return <LoadingContent />;

	return (
		<div className="content">
			<React.Fragment>
				{schemeLoading && (
					<div className="content">
						<div className="row">
							<h5>Loading schemes, hold on...</h5>
						</div>
					</div>
				)}

				{schemes && (
					<>
						<div className="row">
							<div class="pull-left">
								<h5>Pension Schemes</h5>
							</div>
							<div
								className="btn btn-success pull-right"
								onClick={setOpenModal}
								disabled={!permissions}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add New Scheme</div>
							</div>
						</div>
						<div className="form-group">
							<div className="col-xs-9">
								<div className="col-xs-3 pl-0">
									<label>From</label>
									<DatePicker
										selected={startDate}
										onChange={(date) => {
											if (date && format(date, "yyyy-MM-dd") >= format(endDate, "yyyy-MM-dd")) {
												setEndDate(date);
											}
											if (date) setStartDate(date);
										}}
										wrapperClassName="full-width"
										dateFormat="dd/MM/yyyy"
										customInput={<DateInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								<div className="col-xs-3 pl-0">
									<label htmlFor=" ">To</label>
									<DatePicker
										selected={endDate}
										onChange={(date) => {
											if (date && format(date, "yyyy-MM-dd") <= format(startDate, "yyyy-MM-dd")) {
												setStartDate(date);
											}
											if (date) setEndDate(date);
										}}
										wrapperClassName="full-width"
										dateFormat="dd/MM/yyyy"
										customInput={<DateInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								{schemeTypeOptions && (
									<div className="col-xs-3 pl-0">
										<label htmlFor="material-text">Scheme Type</label>
										<Select
											value={type}
											options={schemeTypeOptions}
											onChange={setType}
											isClearable
										/>
										<div className="clearfix" />
									</div>
								)}
								{pensionProviderOptions?.length && (
									<div className="col-xs-3 pl-0">
										<label htmlFor="material-text">Pension Provider</label>
										<Select
											value={pensionProvider}
											options={pensionProviderOptions}
											onChange={setPensionProvider}
											isClearable
										/>
										<div className="clearfix" />
									</div>
								)}
							</div>
							<div className="col-xs-3">
								<div
									id="view-scheme-button"
									className="btn btn-success pull-right"
									style={{
										marginTop: "27px",
									}}
									onClick={updateSchemes}
								>
									{(schemeUpdating && (
										<span>
											<Spinner
												style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
												className="animate-spin -ml-1 mr-3 h-5 w-5 "
											/>
											View Schemes
										</span>
									)) || (
										<span>
											<MagnifyingGlassIcon
												style={{ height: "1.5em", float: "left", marginRight: 5 }}
											/>
											View Schemes
										</span>
									)}
								</div>
							</div>
							<div className="clearfix" />
						</div>
					</>
				)}
				{schemes && !schemeLoading && (
					<div className="table-responsive">
						<div
							id="active-people-table_wrapper"
							className="dataTables_wrapper no-footer"
						>
							<table
								id="active-people-table"
								className="js-table-sections table table-hover"
							>
								<thead style={{ display: "table-header-group" }}>
									<tr>
										<th width="5%"></th>
										<th>NAME</th>
										<th>SCHEME TYPE</th>
										<th>PENSION PROVIDER</th>
										<th>PERIOD</th>
										{/* <th>NUMBER OF EMPLOYEES</th> */}
										<th></th>
									</tr>
								</thead>
								<tbody>
									{schemes.map((entry) => (
										<SchemeRow
											key={entry.id}
											scheme={entry}
										/>
									))}
								</tbody>
							</table>
						</div>
					</div>
				)}
				<DeleteSchemeModal />
			</React.Fragment>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { schemeLoading, schemeUpdating } = state.pensions.scheme;

	const schemeTypeOptions = [
		{ value: "banded", label: "Banded" },
		{ value: "unbanded", label: "Unbanded" },
		{ value: "type1", label: "Type 1" },
		{ value: "type2", label: "Type 2" },
		{ value: "type3", label: "Type 3" },
	];

	const pensionIntegrations = Object.values({ ...state?.integration?.pension }).map(({ name }) => ({
		value: name,
		label: name,
	}));

	const pensionProviderOptions = [{ value: undefined, label: "Other" }, ...pensionIntegrations];

	return {
		schemeTypeOptions,
		pensionProviderOptions,
		schemes: state?.pensions?.scheme?.list || [],
		schemeLoading,
		schemeUpdating,
		org: state?.company?.settings?.org,
		permissions: state?.permissions?.my?.permissions?.pensions != "Read",
	};
};

const mapDispatchToProps = (dispatch) => ({
	getSchemes: (options) => dispatch(SCHEMEACTIONS.getSchemes(options)),
	setOpenModal: () => dispatch(SCHEMEACTIONS.setOpenSchemeModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schemes);
